import React from 'react';
import { InputNumber } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import { SelectAntd, SelectAntdFormik } from '~/components/Pagination/styles';
import InputCurrency from '~/components/Form/InputCurrency';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { Typography } from 'antd';
import { formatPrice, parsePrice } from '~/Utils/format';

export const expensesEventsColumns = (expenses, errors, fluidPermissions, values, setFieldValue) => {
  return [
    {
      title: i18next.t('Nome'),
      dataIndex: 'expense_id',
      key: 'expense_id',
      width: '40%',
      render: (_, record, index) => (
        <FormControl
          field={`event_expenses.${index}.expense.id`}
          error={errors?.event_expenses?.[index]?.expense?.id}
          list
          required
        >
          <SelectAntdFormik
            name={`event_expenses.${index}.expense.id`}
            placeholder="SELECIONE"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            disabled={!fluidPermissions()}
          >
            {expenses?.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      ),
    },
    {
      title: i18next.t('Quantidade'),
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record, index) => (
        <FormControl
          field={`event_expenses.${index}.amount`}
          error={errors?.event_expenses?.[index]?.amount}
          list
          required
        >
          <InputNumber
            name={`event_expenses.${index}.amount`}
            onChange={(value) => {
              setFieldValue(`event_expenses.${index}.amount`, value);

              const currentPrice = values?.event_expenses?.[index]?.price_unit || 0;
              const total = Number(value || 0) * parsePrice(currentPrice);

              setFieldValue(`event_expenses.${index}.price_total`, total);
            }}
            disabled={!fluidPermissions()}
          />
        </FormControl>
      ),
    },
    {
      title: i18next.t('Valor'),
      dataIndex: 'price_unit',
      key: 'price_unit',
      render: (_, record, index) => (
        <FormControl
          field={`event_expenses.${index}.price_unit`}
          error={errors?.event_expenses?.[index]?.price_unit}
          list
          required
        >
          <InputCurrency
            name={`event_expenses.${index}.price_unit`}
            onChange={(e) => {
              const newPrice = e?.target ? e.target.value : e;

              setFieldValue(`event_expenses.${index}.price_unit`, newPrice);

              const currentAmount = values?.event_expenses?.[index]?.amount || 0;
              const total = Number(currentAmount) * parsePrice(newPrice);

              setFieldValue(`event_expenses.${index}.price_total`, total);
            }}
            disabled={!fluidPermissions()}
          />
        </FormControl>
      ),
    },
    {
      title: 'Total',
      dataIndex: 'price_total',
      key: 'price_total',
      render: (_, record) => {
        return <Typography.Text strong>{formatPrice(record.price_total)}</Typography.Text>;
      },
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Button
          color="danger"
          title="Remover despesa"
          size="small"
          style={{ width: '30px' }}
          onClick={() => record.remove(index)}
          disabled={!fluidPermissions()}
          icon={<FaTrash />}
        />
      ),
    },
  ];
};
